module.exports = __webpack_public_path__ + "static/media/5.dce2e369.svg";